<script setup>
import { computed, watch } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useConversationCards } from 'custom/dashboard/composables/zimobi/useConversationCards';
import { useConversationSidebarTab } from 'custom/dashboard/composables/zimobi/useConversationSidebarTab';

const currentChat = useMapGetter('getSelectedChat');
const accountId = useMapGetter('getCurrentAccountId');
const getAccountById = useMapGetter('accounts/getAccount');

const isCardsEnabled = computed(
  () => !!getAccountById.value(accountId.value)?.cards
);

const { openCount, fetchCards } = useConversationCards(
  () => currentChat.value.id
);
const { isCardsTabOpen, openTab } = useConversationSidebarTab();

watch(
  () => [currentChat.value.id, isCardsEnabled.value],
  ([conversationId, enabled]) => {
    if (conversationId && enabled) fetchCards();
  },
  { immediate: true }
);
</script>

<template>
  <div v-if="isCardsEnabled" class="relative">
    <Button
      v-tooltip.bottom="$t('CARDS.CONVERSATION_PANEL.TITLE')"
      ghost
      slate
      sm
      class="!rounded-full"
      :class="{ 'bg-n-alpha-2': isCardsTabOpen }"
      icon="i-lucide-kanban"
      data-testid="conversation-cards-button"
      @click="openTab('cards')"
    />
    <span
      v-if="openCount"
      class="absolute -top-1 ltr:-right-1 rtl:-left-1 grid h-4 px-1 text-[10px] font-semibold text-white rounded-full min-w-4 place-content-center bg-n-brand pointer-events-none"
      data-testid="conversation-cards-count"
    >
      {{ openCount }}
    </span>
  </div>
</template>
